import { useEffect, useRef, useCallback } from 'react'
import { createSafeResizeObserver } from 'lib/utils/resize-observer'

const resizeObserverSupported = typeof ResizeObserver !== 'undefined'

export const useResizeObserver = ({ refToObserve, onResize = () => null }) => {
  const resizeObserver = useRef(null)
  const unobserve = useCallback(() => {
    if (resizeObserver.current != null) {
      resizeObserver.current.disconnect()
    }
  }, [])

  useEffect(() => {
    if (resizeObserverSupported) {
      if (resizeObserver.current == null) {
        resizeObserver.current = createSafeResizeObserver(onResize)
      }

      const currentRef = refToObserve?.current
      if (currentRef) {
        resizeObserver.current.observe(currentRef)
      }

      return () => {
        if (currentRef) {
          unobserve()
        }
      }
    }
  }, [refToObserve, onResize, unobserve])

  return {
    unobserve,
    notSupported: !resizeObserverSupported,
  }
}
